import getCookies from 'shared/utils/getCookies.js';

export default () => getCookies('csrftoken');
